export default function (app) {
    app.directive('ktsLoginAs', function () {
        return {
            template: require('./loginas.html'),
            controller: ['$scope', 'Restangular', '$state', function Controller($scope, Restangular, $state) {
                    $scope.loginas = function () {
                        var r = confirm("Are you sure you want to proceed with the login?");
                        if (r === true) {
                            Restangular.one('users/loginas/' + $scope.user.id).get().then(function () {
                                $state.reload();
                            });
                        }
                    };
                }],
            scope: {
                user: '='
            }
        };
    });

}





// WEBPACK FOOTER //
// ./js/actions/loginas.js